import { Component } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';
import { CodigoProductoEnum } from 'src/app/global/enums/codigo-producto.enum';
import { step1Messages } from 'src/app/messages/step-1-messages';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { NotificacionCorreoServiceVM } from 'src/app/view-model/services/notificacion-correo-vm.service';
import { lengthValidator } from 'src/app/view-model/validators/max-length.validator';
import { environment } from 'src/environments/environment.prod';
import { DialogService } from '../../../../../view-model/services/dialog.service';

@Component({
  selector: 'app-persona-juridica',
  templateUrl: './persona-juridica.component.html',
  styleUrls: ['./persona-juridica.component.scss']
})
export class PersonaJuridicaComponent {
  loading = false;
  processing = false;
  porNotificar = true;
  datosPersonaJuridicaForm: FormGroup;
  isVentaMPOS = false;
  oldCheckoutURL: string = environment.oldCheckout;

  public mensajeErrorDatosPersonales = step1Messages;

  constructor(
    private dialogService: DialogService,
    private notificacionServiceVM: NotificacionCorreoServiceVM,
    private _formBuilder: FormBuilder,
    private marketplaceRedirectService: MarketplaceRedirectService,
    private carroServ: CarroComprasService
  ) {}

  ngOnInit() {
    const parameters = this.carroServ.loadFromUrl();
    if (parameters && parameters.productos.some((prod) => prod.codigoProducto == CodigoProductoEnum.VENTA_MPOS)) {
      this.isVentaMPOS = true;
      this.datosPersonaJuridicaForm = this._formBuilder.group({
        correo: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]{1,}[a-zA-Z0-9_\-\.~]*@[a-zA-Z0-9_\-\.~]{1,}\.[a-zA-Z]{2,4}$/)]),
        tipoNotificacion: new FormControl({ value: 'PJ_VENTA_MPOS', disabled: true }, Validators.required),
        telefono: new FormControl('', [Validators.required, lengthValidator(9, 9), Validators.pattern('^[1-9][0-9]*')])
      });
    } else {
      this.isVentaMPOS = false;
    }
  }

  get mailControl(): FormControl {
    return this.datosPersonaJuridicaForm.get('correo') as FormControl;
  }

  get tipoControl(): FormControl {
    return this.datosPersonaJuridicaForm.get('tipoNotificacion') as FormControl;
  }

  get telefonoControl(): FormControl {
    return this.datosPersonaJuridicaForm.get('telefono') as FormControl;
  }

  async saveCorreo() {
    this.porNotificar = false;

    try {
      await this.notificacionServiceVM
        .guardarCorreoNotificacion(this.datosPersonaJuridicaForm)
        .then((data) => {
          if (data.mensaje != null) {
            this.porNotificar = false;
          } else {
            this.tryAgainMsg();
            this.porNotificar = true;
          }
        });
    } catch (error) {
      this.tryAgainMsg();
      this.porNotificar = true;
    } finally {
      this.loading = false;
      this.processing = false;
    }
  }

  tryAgainMsg() {
    this.dialogService.openErrorDialog('Danos tu correo nuevamente', 'Tuvimos un problema y no pudimos registrar tu correo electrónico.');
  }

  onSubmmit() {
    this.redirectToOldCheckout();
  }

  async redirectToOldCheckout() {
    const product = this.carroServ.getCurrentProduct();
    if (!product) {
      if (this.carroServ.getRetoma()) {
        this.marketplaceRedirectService.redirectOld();
      } else {
        const respuesta = this.dialogService.openSolicitudVacia();
        respuesta.afterClosed().subscribe((resp) => {
          if (resp.action === 'OK' || resp.action === 'CANCEL') {
            this.marketplaceRedirectService.redirect();
          }
        });
      }
    } else {
      if (product.codigoProducto === 'CREACION_SITIO_ALIANZA_WIX') {
        window.location.href = this.oldCheckoutURL;
      } else {
        const urlExterna = product.urlExterna;
        window.location.href = urlExterna;
      }
    }
  }
}
